import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: Ron Schaeffer
 * id CF2F1BF8-9CBF-41EC-91EF-26B8F2B6A80E
 * name volume-equal
 * version: 6.9.96
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/volume-equal.svg
 * tags
 * - Audio 
 */
export const VolumeEqualIcon = createSvgIcon(<><path d="M3 9H7L12 4V20L7 15H3V9M14 13H22V15H14M14 9H22V11H14Z" /></>, 'VolumeEqualIcon');
export default VolumeEqualIcon